import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import useSchoolCalendar from './useSchoolCalendar';
import SchoolCalendarSummaryCard from './SchoolCalendarSummaryCard';

export default function SchoolCalendarSettingsSummary({ schoolYearStart, contextKey }) {
  const { data, error, refresh } = useSchoolCalendar({ schoolYearStart, contextKey });
  return (
    <div className="mb-3">
      {data && (
        <SchoolCalendarSummaryCard
          calendar={data}
          actions={data.status !== 'updating' && (
            <Link className="btn manage-button manage-teal-button" to={`/manage/settings/school-calendar?schoolYearStart=${schoolYearStart}`}>
              {data.teachingPeriod ? 'Zarządzaj kalendarzem' : 'Skonfiguruj kalendarz'}
            </Link>
          )}
        />
      )}
      {error && (
        <div className="school-calendar-panel">
          <p role="alert">{error.code === 'SCHEDULE_UPDATING' ? 'Trwa aktualizacja kalendarza.' : 'Nie udało się pobrać kalendarza szkoły.'}</p>
          <button type="button" className="manage-teal-button" onClick={refresh}>Spróbuj ponownie</button>
        </div>
      )}
      {!data && !error && <p role="status">Ładowanie kalendarza szkoły…</p>}
    </div>
  );
}
SchoolCalendarSettingsSummary.propTypes = { schoolYearStart: PropTypes.number.isRequired, contextKey: PropTypes.string.isRequired };
